import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useAuthenticatorStyles = makeStyles((theme: Theme) => ({
  authFailedContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(6),
  },
  authFailedPaper: {
    width: 360,
    maxWidth: '95vw',
    padding: theme.spacing(2),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))
